export { renderFilters } from './filters-page';
